export * from './report'

export const compliantStatusTypes = {
  COMPLIANT: 'Compliant',
  NOT_COMPLIANT: 'NotCompliant',
  NOT_COMPLIANT_WITH_REASON: 'NotCompliantWithReason',
}

export const deliveryTypes = {
  pickup: 'PICKUP',
  ship: 'SHIP',
}

export const deliveryMethodTypes = [
  {
    name: 'Shipping',
    value: 'SHIP',
  },
  {
    name: 'Pickup',
    value: 'PICKUP',
  },
]

export const paymentStatusTypes = {
  paid: 'PAID',
  pending: 'PENDING',
  failed: 'PAYMENT_FAILED',
  partialRefund: 'PARTIALLY_REFUNDED',
  refunded: 'REFUNDED',
}

export const fulfillmentStatusTypes = {
  fulfilled: 'FULFILLED',
  unfulfilled: 'UNFULFILLED',
  restocked: 'RESTOCKED',
  readyToFulfill: 'READY_TO_FULFILL',
}

export const taskStatusTypes = {
  success: 'SUCCESS',
  queued: 'QUEUED',
  error: 'ERROR',
  new: 'NEW',
  processing: 'PROCESSING',
}

export const globalFilter = {
  css: 'btn p-2 w-100 btn-tab rotate fs-6 btn-active-color-text-primary justify-content-center border border-gray-400 rounded-0 hide-toggle min-w-100px',
}

export const subscriptionStatus = {
  locked: 'LOCKED',
  active: 'ACTIVE',
  inActive: '',
  suspended: 'SUSPENDED',
}

export const eventNames = {
  invoicePayment: 'invoicePayment',
  retryWineClubOrder: 'wineClubOrderRetry',
  fulfillmentRetry: 'fulfillmentRetry',
  orderCreate: 'orderCreate',
  orderEdit: 'orderEdit',
  orderCancel: 'orderCancel',
  segmentCreate: 'segmentCreate',
  campaignCreate: 'campaignCreate',
  packageSlipCreate: 'packageSlipCreate',
  fulfilledLocationChange: 'fulfilledLocationChange',
  externalOrderCreate: 'externalOrderCreate',
}

export const targetValueType = {
  quantity: 'QUANTITY',
  orderValue: 'ORDER_VALUE',
}

export const premiumFeaturesType = {
  POS: 'POS',
  QuickBooks: 'QUICKBOOKS',
}

export const paymentProviderTypes = {
  stripe: 'stripe',
  elavon: 'elavon',
  payengine: 'pay_engine',
}

export const addPaymentStatus = {
  succeeded: 'SUCCEEDED',
  declined: 'DECLINED',
  cancelled: 'CANCELLED',
  error: 'ERROR',
  requireAction: 'REQUIRES_ACTION',
}

export const wineClubSubscriptionStatus = {
  cancelled: 'cancelled',
  pause: 'pause',
  switched: 'switched',
}

export const memberShipStatus = {
  active: 'ACTIVE',
  pause: 'PAUSE',
}

export const orderTypes = {
  POS: 'POS',
  ADMIN_PORTAL: 'ADMIN_PORTAL',
  WINE_CLUB: 'WINE_CLUB',
}

export const shippingComplianceProviderTypes = {
  sovos: 'sovos',
  avalara: 'avalara',
  manual: 'manual',
}

export const apiResponseStatus = {
  succeeded: 'succeeded',
  failed: 'failed',
  error: 'error',
}
